import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fa from './fa';
// Persian-only. Language switching has been removed.
i18n.use(initReactI18next).init({
    resources: { fa: { translation: fa } },
    lng: 'fa',
    fallbackLng: 'fa',
    interpolation: { escapeValue: false },
});
if (typeof document !== 'undefined') {
    document.documentElement.lang = 'fa';
    document.documentElement.dir = 'rtl';
}
export default i18n;
